
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
    ApplicationDeliveryType
} from '@/commons/constants/application'
import { ApplicationDocument } from '@/commons/types'

@Component
export default class ModalBoxCourierDeliveryContent extends Vue {
    @Prop() applicationDocument!: ApplicationDocument

    setCourierDelivery (): void {
        this.applicationDocument.delivery.type = ApplicationDeliveryType.COURIER_RETRIEVAL
    }

    cancel (): void {
        this.applicationDocument.delivery.location = null
        this.applicationDocument.delivery.type = null
    }
}
